import React from 'react';

/** Renders the findings' tiny markdown subset (**bold**, `code`) as React
 *  nodes — the text is generated by our own deterministic rules engine. */
export const MdLite: React.FC<{ text: string }> = ({ text }) => {
    const parts = text.split(/(\*\*[^*]+\*\*|`[^`]+`|_[^_]+_)/g).filter(Boolean);
    return (
        <>
            {parts.map((p, i) => {
                if (p.startsWith('**') && p.endsWith('**')) return <strong key={i}>{p.slice(2, -2)}</strong>;
                if (p.startsWith('`') && p.endsWith('`')) return <code key={i}>{p.slice(1, -1)}</code>;
                if (p.startsWith('_') && p.endsWith('_') && p.length > 2) return <em key={i}>{p.slice(1, -1)}</em>;
                return <React.Fragment key={i}>{p}</React.Fragment>;
            })}
        </>
    );
};
